module.exports = __webpack_public_path__ + "static/RuinsAuthorLetter-3e018df96d01a46091022461905844cb.pdf";